export const RequestHeaderKeyTypes = {
  RESPONSE_TYPE: 'responseType',
  CONTENT_TYPE: 'Content-Type',
};

export const RequestHeaderValueTypes = {
  BLOB: 'blob',
  MULTIPART_FORM_DATA: 'multipart/form-data',
};
